import React, { useRef } from 'react'
import { Button } from 'primereact/button'
import { InputTextarea } from 'primereact/inputtextarea'
import { FileUpload } from 'primereact/fileupload'

interface FileUploadSectionProps {
  newComment: string
  setNewComment: (val: string) => void
  selectedFiles: File[]
  onFileUpload: (event: any) => void
  onRemoveFile: (index: number) => void
  onPreviewImage: (file: File) => void
  onSendComment: () => void
  isLoading: boolean
  isClosed: boolean
  isTicketSelected: boolean
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  newComment,
  setNewComment,
  selectedFiles,
  onFileUpload,
  onRemoveFile,
  onPreviewImage,
  onSendComment,
  isLoading,
  isClosed,
  isTicketSelected,
}) => {
  const acceptedFileTypes = 'image/*'
  const fileUploadRef = useRef<any>(null)

  if (isClosed || !isTicketSelected) return null

  return (
    <div className="ticket-chat__input-container">
      {/* Selected files preview */}
      {selectedFiles.length > 0 && (
        <div className="ticket-chat__files-preview">
          <div className="ticket-chat__files-preview__title">
            Selected files ({selectedFiles.length}/5):
          </div>
          <div className="ticket-chat__files-preview__list">
            {selectedFiles.map((file, index) => (
              <div
                key={index}
                className="ticket-chat__files-preview__item"
                onClick={() => onPreviewImage(file)}
              >
                <i className="pi pi-image ticket-chat__files-preview__icon" />
                {file.name}
                <Button
                  icon="pi pi-times"
                  className="p-button-text p-button-sm ticket-chat__files-preview__remove-btn"
                  onClick={(e) => {
                    e.stopPropagation()
                    onRemoveFile(index)
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="ticket-chat__input-row">
        <InputTextarea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Add New Comment (Press Enter to send)"
          autoResize
          rows={1}
          className="ticket-chat__textarea"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault()
              onSendComment()
            }
          }}
        />
                 <FileUpload
           ref={fileUploadRef}
           mode="basic"
           name="attachments[]"
           accept={acceptedFileTypes}
           maxFileSize={5000000}
           customUpload
           uploadHandler={(e) => {
             onFileUpload(e)
             // Clear the file input after selection to prevent duplication
             if (fileUploadRef.current) {
               fileUploadRef.current.clear()
             }
           }}
           auto
           chooseLabel="📷"
           className="ticket-chat__upload-btn"
           disabled={selectedFiles.length >= 5}
         />
        <Button
          icon="pi pi-send"
          className="p-button-rounded p-button-info ticket-chat__send-btn"
          onClick={onSendComment}
          loading={isLoading}
          disabled={!newComment && selectedFiles.length === 0}
        />
      </div>
    </div>
  )
}

export default FileUploadSection 